import { devLog } from './devLog';

/**
 * Returns true for internal system/analysis messages that should never be
 * shown to the user in the chat UI. Used by both ChatContext and useSessionManager.
 */
export const isInternalAnalysisMessage = (content: string): boolean => {
  if (!content || typeof content !== 'string') {
    return false;
  }

  devLog('🔍 FILTER: Testing content for internal analysis patterns:', content.substring(0, 200));

  const internalRequestPatterns = [
    // Original patterns for analysis requests
    /^Analyze remote viewing session for Target [A-Z0-9]{4}-[A-Z0-9]{4}\./,
    /^Target [A-Z0-9]{4}-[A-Z0-9]{4} revealed\./,
    // Additional patterns for internal prompts that may leak
    /^TARGET:\s*(Type:|https?:)/,
    /^USER_IMPRESSIONS:/,
    /^ANALYSIS_REQUEST:/,
    /^Please analyze the following remote viewing session/,
    /^Based on the target details and user impressions/,
    // Filter tool messages and internal processing
    /^\[TOOL_CALL\]/,
    /^\[INTERNAL_ANALYSIS\]/,
    /^SYSTEM_PROMPT:/,
    // Filter any message that contains internal analysis structure patterns
    /TARGET:.*TYPE:.*USER'S IMPRESSIONS:/s,
    /^\[INTERNAL_ANALYSIS\]\s*Analyze remote viewing session/,
    // Enhanced patterns to catch variations
    /^TARGET:.*USER'S IMPRESSIONS:/s,
    /^Analyze remote viewing session/,
    /CRITICAL INSTRUCTION: Use ONLY second person language/,
    /VISION_ANALYSIS_REQUEST/,
    /IMAGE_COUNT:/,
    /Examples of CORRECT language:/,
    /Examples of INCORRECT language/,
  ];

  const isInternal = internalRequestPatterns.some(pattern => pattern.test(content));

  if (isInternal) {
    devLog('🚫 FILTER: BLOCKED internal analysis message:', content.substring(0, 150));
  }

  return isInternal;
};
